import React from 'react';
import './Drops.css';

const Drops = () => {
  const drops = [
    {
      id: 1,
      title: "Shadow Collection",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20.38 3.46L16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>
          <path d="M12 8v4l3 3"/>
        </svg>
      )
    },
    {
      id: 2,
      title: "Anonymous Drop",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
      )
    }
  ];

  return (
    <section id="drops" className="drops-section">
      <div className="container">
        <div className="drops-header">
          <h2 className="section-title">Latest Drops</h2>
        </div>
        <div className="drops-grid">
          {drops.map((drop) => (
            <div key={drop.id} className="drop-item">
              <div className="drop-icon">
                {drop.icon}
              </div>
              <h3 className="drop-title">{drop.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Drops;
